<template>
  <v-form ref="form" v-model="formValid" @submit.prevent="onSubmit">
    <LicensePlateField
      v-model="form.license_plate"
      :originalValue="{
        license_plate: item.license_plate,
        license_plate_country_code: item.license_plate_country_code
      }"
      required
      :submitError="submitError"
      @valid="valid => (licensePlateValid = valid)"
      @validating="validating => (validatingLicensePlateLoader = validating)"
      @clear-error="$emit('clear-error')"
    />

    <v-card-actions class="px-0">
      <v-btn text color="grey" :disabled="loading" @click="$emit('cancel')">
        {{ $t("button.cancel") }}
      </v-btn>
      <v-spacer />
      <v-btn
        color="primary"
        type="submit"
        :loading="loading"
        :disabled="!canSave"
      >
        {{ $t("button.save") }}
      </v-btn>
    </v-card-actions>
  </v-form>
</template>

<script>
import LicensePlateField from "@/components/fields/LicensePlateField.vue";

export default {
  name: "SubscriptionEditForm",
  components: { LicensePlateField },
  props: {
    item: {
      type: Object,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    submitError: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      form: {
        ...this.item,
        license_plate: {
          license_plate: this.item.license_plate || "",
          license_plate_country_code: this.item.license_plate_country_code || ""
        }
      },
      formValid: false,
      validatingLicensePlateLoader: false,
      licensePlateValid: false
    };
  },
  watch: {
    item(val) {
      this.form = {
        ...val,
        license_plate: {
          license_plate: val.license_plate || "",
          license_plate_country_code: val.license_plate_country_code || ""
        }
      };
    }
  },
  computed: {
    licensePlateChanged() {
      return (
        this.form.license_plate.license_plate !==
          (this.item.license_plate || "") ||
        this.form.license_plate.license_plate_country_code !==
          (this.item.license_plate_country_code || "")
      );
    },
    canSave() {
      if (!this.formValid) return false;
      if (this.loading || this.validatingLicensePlateLoader) return false;
      if (!this.licensePlateChanged) return false;
      if (!this.licensePlateValid) return false;
      return true;
    }
  },
  methods: {
    onSubmit() {
      if (!this.$refs.form.validate() || !this.canSave) return;
      this.$emit("submit", {
        dispatch: "subscription/putSubscription",
        data: {
          ...this.form,
          license_plate: this.form.license_plate.license_plate,
          license_plate_country_code: this.form.license_plate
            .license_plate_country_code
        }
      });
    }
  }
};
</script>
